import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import styles from './AvailabilityMap.scss';

const MapRow = ({ color, title }) => (
    <Col xs={3} md={3} xl={3} className="mb-3 pb-3">
        <span style={{ background: color }} className={`${styles['map-legend-box']} align-middle`} />
        <span className="align-middle">
            {title}
        </span>
    </Col>
);

MapRow.propTypes = {
    color: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

const AvailabilityMapLegend = ({ legend }) => (
    <Row className={`${styles['map-legend-container']} justify-content-center`}>
        {
            legend.map((item) => (
                <MapRow
                    key={item.title}
                    color={item.color}
                    title={item.title}
                />
            ))
        }
    </Row >
);

AvailabilityMapLegend.propTypes = {
    legend: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
    })),
};

export default React.memo(AvailabilityMapLegend);
